import { Popover } from "radix-ui";
import type { ReactNode } from "react";
import { REACTION_EMOJIS } from "@atrium/shared";

export function EmojiPicker({
  children,
  onPick,
  open,
  onOpenChange,
  align = "end",
  label = "Reactions",
}: {
  children: ReactNode;
  onPick: (emoji: string) => void;
  open?: boolean;
  onOpenChange?: (o: boolean) => void;
  align?: "start" | "center" | "end";
  label?: string;
}) {
  return (
    <Popover.Root open={open} onOpenChange={onOpenChange}>
      <Popover.Trigger asChild>{children}</Popover.Trigger>
      <Popover.Portal>
        <Popover.Content side="top" align={align} sideOffset={6} collisionPadding={8} className="z-[60] rounded-lg bg-surface p-1.5 shadow-pop animate-pop-in">
          <div className="grid grid-cols-8 gap-0.5" role="listbox" aria-label={label}>
            {REACTION_EMOJIS.map((e) => (
              <Popover.Close asChild key={e}>
                <button role="option" aria-label={label === "Reactions" ? `React with ${e}` : e} onClick={() => onPick(e)} className="flex size-9 items-center justify-center rounded-md text-xl hover:bg-surface-3">
                  {e}
                </button>
              </Popover.Close>
            ))}
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
